



















































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CommonMenuNavigationDrawer extends Vue {
  private isDrawerClose: boolean = false;
  private isDrawerClick: boolean = true;
  private menuContentFields = [
    {
      title: 'ホーム',
      icon: 'mdi-home-city-outline',
      route: 'home',
      index: 0,
    },
    {
      title: '課題',
      icon: 'mdi-format-list-bulleted-type',
      route: 'taskList',
      index: 1,
    },
    { title: 'ドキュメント', icon: 'mdi-notebook', route: 'documents', index: 2 },
    {
      title: 'ストレージ',
      icon: 'mdi-folder-outline',
      route: 'storage',
      index: 3,
    },
    { title: 'Git', icon: 'mdi-source-fork', route: 'git', index: 4 },
    {
      title: '求人案件',
      icon: 'mdi-text-box-search-outline',
      route: 'recruitmentDashboard',
      index: 5,
    },
    {
      title: '人材検索',
      icon: 'mdi-magnify',
      route: 'humanResourceSearch',
      index: 6,
    },
    {
      title: 'メンバー',
      icon: 'mdi-account-cog-outline',
      route: 'member',
      index: 7,
    },
    {
      title: '設定',
      icon: 'mdi-cog',
      route: 'projectConfigBasic',
      index: 8,
    },
  ];

  private selectedMenu(index: number) {
    const selectedMenu = this.menuContentFields.find(
      (x: any) => x.index === index
    );
    if (selectedMenu) {
      this.$router.push({ name: selectedMenu.route });
    }
  }

  private isSelectMenu(index: number) {
    const selectedMenu = this.menuContentFields.find(
      (x: any) => x.index === index
    );
    if (selectedMenu) {
      if (this.$route.name === selectedMenu.route) return true;
    } else {
      return false;
    }
  }
  /**
   * サイドメニューの判定
   * マウスリーブ :true(非表示)
   * マウスオーバー :false(表示)
   */
  private sideMenuDisplay(flg: boolean) {
    if (!this.isDrawerClick) {
      this.isDrawerClose = flg;
      this.$emit('chgFlg', this.isDrawerClose);
    }
  }
  private changeSideFlg() {
    this.isDrawerClick = !this.isDrawerClick;
    this.$emit('chgFlg', this.isDrawerClose);
  }
}
